import { render, staticRenderFns } from "./the-lang-select.vue?vue&type=template&id=df97a2fa&scoped=true"
import script from "./the-lang-select.vue?vue&type=script&lang=js"
export * from "./the-lang-select.vue?vue&type=script&lang=js"
import style0 from "./the-lang-select.vue?vue&type=style&index=0&id=df97a2fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df97a2fa",
  null
  
)

export default component.exports